import type { OrchestratorSessionDto } from '../api/orchestratorAuth';

/** True when `/auth/me` reports an in-flight MFA step-up (no full authSession yet). */
export function isMfaChallengePendingSession(
  session: OrchestratorSessionDto | null | undefined,
): boolean {
  return Boolean(session?.mfaChallengePending === true);
}

export type AdminSessionMfaChallengeProbe = {
  ready: false;
  reason: 'mfa_challenge';
};

/** True when probe found a live MFA challenge — do not call terminateOperatorSession. */
export function isAdminSessionMfaChallenge(probe: {
  ready: boolean;
  reason?: string;
}): probe is AdminSessionMfaChallengeProbe {
  return !probe.ready && probe.reason === 'mfa_challenge';
}

/** Auth-server recovery code normalize (strip non-alphanumeric, upper). */
export function normalizeAdminMfaRecoveryCode(value: string): string {
  // Drop optional "1. " prefixes from older download files before hashing shape.
  const withoutIndex = String(value || '')
    .trim()
    .replace(/^\d+\.\s*/, '');
  return withoutIndex.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}
